export default __webpack_public_path__ + "static/media/p_wdt_c_2.512973f1.mp3";